"use client";

import { useTranslations } from "next-intl";
import type { ReactNode } from "react";
import { Logo } from "@/components/logo";
import { Link } from "@/i18n/navigation";
import { PublicLanguageSelect } from "@/components/public-language-select";

export function MarketingFooter({ children, description, showExamNotice = true }: { children?: ReactNode; description?: string; showExamNotice?: boolean }) {
  const t = useTranslations("MarketingFooter");
  const linkClass = "inline-flex min-h-11 items-center py-2 text-accent underline-offset-4 hover:underline focus-visible:outline-2 focus-visible:outline-accent";

  return <footer id="contato" className="mx-auto max-w-6xl border-t border-border px-5 py-8 text-sm text-muted sm:px-8">
    <div className="grid gap-8 sm:grid-cols-2">
      <div>
        <Logo href="/" ariaLabel="Aulyn" />
        <p className="mt-4 max-w-md text-xs leading-6">{description ?? t("description")}</p>
        <p className="mt-3 font-medium text-foreground">{t("operator")}</p>
        <address className="mt-2 max-w-sm text-xs not-italic leading-6">8206 Louisiana Blvd NE, Ste A #6992, Albuquerque, New Mexico 87113, {t("country")}</address>
        {children && <div className="mt-3 text-xs leading-6">{children}</div>}
      </div>
      <div>
        <h2 className="font-semibold text-foreground">{t("support")}</h2>
        <a href="mailto:contact@aulyn.chat" className={`${linkClass} break-all`}>contact@aulyn.chat</a>
        <nav aria-label={t("socials")} className="mt-2 flex flex-wrap gap-x-6">
          <a href="https://www.instagram.com/aulyn.chat/" target="_blank" rel="noopener noreferrer" className={linkClass}>Instagram @aulyn.chat</a>
          <a href="https://www.tiktok.com/@aulyn.chat" target="_blank" rel="noopener noreferrer" className={linkClass}>TikTok @aulyn.chat</a>
        </nav>
      </div>
    </div>
    {showExamNotice && <p className="mt-6 max-w-3xl text-xs leading-6">{t("independent")}</p>}
    <nav aria-label={t("legal")} className="mt-6 flex flex-wrap items-center gap-x-6 border-t border-border pt-4 text-xs">
      <Link href="/sobre" className={linkClass}>{t("about")}</Link>
      <Link href="/privacy-policy" className={linkClass}>{t("privacy")}</Link>
      <Link href="/terms-of-service" className={linkClass}>{t("terms")}</Link>
      <Link href="/#demonstracao" className={linkClass}>{t("institutions")}</Link>
      <PublicLanguageSelect />
    </nav>
  </footer>;
}
